<template>
    <div class="item-body">
      sdds 
    </div>
</template>
<script>
export default {
    data(){
        return{
            lang:false,//语言
        }
    },
    watch:{
        lang:function(newValue,old){
            console.log('2',newValue,old);
        }
    },
    mounted(){
        this.lang=this.$i18n.locale=='en-Us'?true:false;
    },
    methods:{
        /**
         * 基于描点链接
         */
        routerClick(path){
            document.getElementById(path).scrollIntoView();
        },
    }
}
</script>

<style lang="scss" scoped>
.item-body{
    
    text-align: center;
    width:100%;
   
    margin-top:1rem;
}
   
</style>



// WEBPACK FOOTER //
// src/view/item.vue